import { ArrowRight } from "lucide-react";
import { services } from "@/config/content";
import { Reveal } from "@/lib/motion";
import { requestService } from "@/lib/nav";

const ServiceCard = ({ s, featured }) => (
  <article
    data-testid={`service-card-${s.id}`}
    className={`group relative flex flex-col rounded-2xl border border-border bg-white overflow-hidden shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_12px_40px_rgb(0,0,0,0.08)] transition-shadow duration-300 ${featured ? "lg:col-span-8" : "lg:col-span-4"}`}
  >
    <div className={`relative overflow-hidden ${featured ? "aspect-[16/9] lg:aspect-[16/8]" : "aspect-[16/10]"}`}>
      <img src={s.image} alt={s.alt} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[900ms] ease-out" />
      <span className="absolute top-4 left-4 inline-flex items-center gap-2 bg-white/95 backdrop-blur rounded-full px-3 py-1.5">
        <s.icon className="w-4 h-4 text-forest" strokeWidth={1.75} />
        <span className="text-xs font-heading font-bold text-forest tracking-wide">{s.number}</span>
      </span>
    </div>
    <div className={`flex flex-col flex-1 p-6 lg:p-8 ${featured ? "lg:grid lg:grid-cols-2 lg:gap-8" : ""}`}>
      <div>
        <h3 className="font-heading font-bold text-xl sm:text-2xl text-charcoal leading-tight">{s.title}</h3>
        <p className="mt-3 text-charcoal-muted leading-relaxed">{s.lead}</p>
      </div>
      <div className="mt-5 lg:mt-0 flex flex-col">
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2">
          {s.items.map((it) => (
            <li key={it} className="flex items-start gap-2 text-sm text-charcoal">
              <span className="mt-2 w-1.5 h-1.5 rounded-full bg-gold shrink-0" /> {it}
            </li>
          ))}
        </ul>
        {s.note && <p className="mt-4 text-xs leading-relaxed text-charcoal-muted bg-sand border border-border rounded-lg p-3">{s.note}</p>}
        <button
          onClick={() => requestService(s.value)}
          data-testid={`service-cta-${s.id}`}
          className="mt-5 self-start inline-flex items-center gap-2 rounded-md bg-forest px-5 py-2.5 text-sm font-semibold text-white hover:bg-forest-dark hover:-translate-y-0.5 transition-[transform,background-color] duration-200"
        >
          {s.cta} <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  </article>
);

export const Services = () => (
  <section id="leistungen" className="py-20 lg:py-28 bg-white scroll-mt-20" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-3xl">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold-dark mb-4">Leistungen</p>
        <h2 className="font-heading font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-charcoal leading-[1.15]">
          Unsere Leistungen für Ihre Immobilie
        </h2>
        <p className="mt-5 text-lg text-charcoal-muted leading-relaxed">
          Unsere Kernleistung ist die Gebäudereinigung. Darüber hinaus bieten wir weitere Services
          rund um Ihr Objekt – Objektpflege, Trockenbau und Innenausbau.
        </p>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
        {services.map((s, i) => (
          <Reveal key={s.id} delay={i * 0.05} className={s.featured ? "lg:col-span-8" : "lg:col-span-4"}>
            <ServiceCard s={s} featured={s.featured} />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
